interface IProps {
    value: string;
    cardFlag: string;
}

interface IReturn {
    message: string;
    status: 'Error' | '';
}

const validateSecurityCode = ({ value, cardFlag }: IProps): IReturn => {
    value = value.replace(/\D/g, '');
    if (cardFlag === 'amex' && value.length < 4) {
        return {
            message: 'Preenchimento incorreto',
            status: 'Error',
        };
    }
    if (value.length === 0) {
        return {
            message: 'Preenchimento obrigatório',
            status: 'Error',
        };
    } else if (value.length < 3) {
        return {
            message: 'Preenchimento incorreto',
            status: 'Error',
        };
    }
    return {
        message: '',
        status: '',
    };

}

// const validateSecurityCode = useCallback(
//     (e: React.FormEvent<HTMLInputElement>) => {
//       if (cardFlag === 'amex') {
//         e.currentTarget.maxLength = 4;
//       } else {
//         e.currentTarget.maxLength = 3;
//       }

//       let value = e.currentTarget.value;
//       value = value.replace(/\D/g, '');
//       if (value.length === 0) {
//         setCodSecStatus('Error');
//         setCodSecError('Preenchimento obrigatório');
//       } else if (value.length < 3) {
//         setCodSecStatus('Error');
//         setCodSecError('Preenchimento incorreto');
//       } else {
//         setCodSecStatus('');
//         setCodSecError('');
//       }
//       e.currentTarget.value = value;
//       setCodSec(value);
//     },
//     [cardFlag]
//   );

export { validateSecurityCode };
